import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { TestChildResource } from "./TestChildResource";

export class TestResource {
  constructor(public readonly testStringNotMember: string, public readonly testFieldString: string, public readonly testOtherThing: string, public readonly testFieldDate: Date, public readonly testFieldDateTime: Date, public readonly testFieldNullable: boolean | null, public readonly computedValueTest: string | null, public readonly stringTest: string, public readonly id: number, public readonly testChildren: Array<TestChildResource> | null) {
    this.cbiServiceContext = null;
    this.testChildrenLoaded = this.testChildren != null;
    this.testChildrenCached = this.testChildren;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private testChildrenLoaded: boolean;
  private testChildrenCached: Array<TestChildResource> | null;
  async testChildrenLazy(): Promise<Array<TestChildResource>> {
    if (!this.testChildrenLoaded) {
      this.testChildrenCached = await this.cbiServiceContext!.testResourceService().getTestResourceTestChildren(this.id);
      this.testChildrenLoaded = true;
    }
    return this.testChildrenCached!;
  }
  async loadChildrenFromReference(): Promise<void> {
    return await this.cbiServiceContext!.testResourceService().loadChildrenFromReferenceStaff({ id: this.id });
  }
  async verifyBoundResource(): Promise<void> {
    return await this.cbiServiceContext!.testResourceService().verifyBoundResourceStaff({ id: this.id });
  }
}
